import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Hypnose = ({ data }) => {
  return (
    <Layout>
      <SEO title="Hypnose" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h2>Hypnose</h2>
          </div>
          <div className="col-md-6">
            <Img
              fluid={data.img1.childImageSharp.fluid}
              alt="Reflet montagne"
            />
          </div>
          <div className="col-md-6">
            <p>
              Pour compléter les apports de la sophrologie, l’hypnose permet
              d’apporter un soulagement rapide. Tandis que la sophrologie agit
              en douceur, de manière progressive, l’hypnose permet d’intervenir
              à un niveau plus profond, au niveau des causes. Elle agit comme un
              accélérateur du processus de résilience.
            </p>
            <p>
              Elle permet de modifier nos comportements inconscients
              (compulsions, addictions, …) ainsi que nos anciens
              conditionnements devenus inadaptés à nos besoins présents. Elle
              permet de mettre en place de manière consciente et consentie de
              nouvelles solutions, plus adaptées à nos besoins actuels, notre
              santé, notre bien-être et plus propices à notre évolution
              personnelle.
            </p>
          </div>
          <div className="col-md-12">
            <p>
              Outre les techniques principales d’hypnose éricksonnienne et de
              Nouvelle Hypnose, l’hypnose que je pratique majoritairement,
              s’inscrit dans le courant de l’Hypnose Humaniste, créée par
              Olivier Lockert, Président de l’Institut Français d’Hypnose
              Humaniste & Ericksonienne (IFHE). Ce type d’hypnose permet à la
              personne accompagnée de changer en toute conscience, et de
              participer activement à sa guérison. Elle agit sur elle-même de
              manière autonome, en gardant son libre arbitre pour trouver ses
              propres solutions. Comme lors d'une séance de sophrologie, le
              thérapeute intervient simplement en guide, mais c’est
              l'interaction qui lui permet de savoir où en est la personne et de
              l’accompagner dans les changements qu’elle souhaite opérer. Les
              changements sont initiés par la prise de conscience, l'accès à une
              nouvelle compréhension et par une action symbolique positive.
              Ainsi pacifiée et chargée de nouvelles informations et de
              nouvelles représentations, la personne peut aborder son quotidien
              d'une manière nouvelle, plus libre, plus confiante et plus
              optimiste quant à l'avenir.
            </p>
            <p>
              Cette pratique d’hypnose est applicable à tous, enfants,
              adolescents et adultes.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    img1: file(relativePath: { eq: "reflet-montagne.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export default Hypnose
